import { useNavigate } from "react-router-dom";
import img from "../../assets/images/InceptionFinicallyLogo.png";
import { colors } from "../../../src/utils/theme";
import CustomButton from "../../components/Button/CustomButton";
import CustomInput from "../../components/CustomInput";
import styles from "./index.module.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { proformaLoginSchema } from "../../yup";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLoginMutation } from "../../services/proformaApi";
import { setProformaUser } from "../../store/reducers/proformaReducer";
import { tracker } from "../../services/mixpanel";

const LoginProforma = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(proformaLoginSchema),
  });

  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [login] = useLoginMutation();
  const hasStarted = useRef(false);

  const onSubmit = async (values: { name: string; pin: string }) => {
    try {
      setIsLoading(true);
      const result = await login(values).unwrap();
      tracker.proforma.identify(result?.data?._id);
      tracker.proforma.formSubmit(result?.data?._id);
      const userDetails = {
        name: result.data?.name,
        designation: result.data?.designation,
        contactGroupId: result.data?.contactGroup?._id,
        contactGroupName: result.data?.contactGroup?.contactGroupName,
        inceptionDevFee: result.data?.contactGroup?.inceptionDevFee,
        developerDevFee: result.data?.contactGroup?.developerDevFee,
        itcPercent: result.data?.contactGroup?.itcPercent,
        folderId: result.data?.contactGroup?.folderId,
        lowScenerio: result.data?.contactGroup?.lowScenerio,
        lowMidScenerio: result.data?.contactGroup?.lowMidScenerio,
        highMidScenerio: result.data?.contactGroup?.highMidScenerio,
        highScenerio: result.data?.contactGroup?.highScenerio,
        isAdmin: result.data?.isAdmin ?? false,
        isNewVersion: result.data?.isNewVersion ?? true,
      };
      localStorage.setItem("token", result.data.token || "");
      dispatch(setProformaUser(userDetails));
      reset();
      setErrMsg("");
      navigate("/proforma");
    } catch (error: any) {
      console.error("Login error:", error);
      const message = error?.data?.message ?? "An error occurred during login."
      tracker.proforma.loginFailed(getValues("name") || "",message);
      setErrMsg(message);
    } finally {
      setIsLoading(false);
    }
  };

  const onError = () => {
    const name = getValues("name");
    tracker.proforma.loginForm(name || "");
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setValue(name as "name" | "pin", value);
    setErrMsg("");
  };

  useEffect(() => {
    if (isDirty && !hasStarted.current) {
      hasStarted.current = true;
      tracker.proforma.formStarted();
    }
  }, [isDirty]);

  useEffect(() => {
    tracker.proforma.pageView();
  }, []);

  return (
    <div className={styles.customClass}>
      <div className={styles.content}>
        <div className="w-full flex items-center justify-center">
          <div className="w-[90vw] h-[90vh] relative flex flex-col items-center justify-center">
            <div className="flex justify-start px-10 pb-20 absolute top-0 left-0">
              <img src={img} alt="" className={`${styles.image}`} />
            </div>
            <form
              className="flex flex-col h-1/2 w-full md:w-[40%] items-center justify-center"
              onSubmit={handleSubmit(onSubmit, onError)}
              noValidate
            >
              <div className="w-[70%] mb-8">
                <CustomInput
                  placeholder="User Name"
                  name="name"
                  type="text"
                  register={register}
                  error={errors.name}
                  onChange={onChange}
                />
              </div>
              <div className="w-[70%] mb-2">
                <CustomInput
                  placeholder="Pin"
                  name="pin"
                  type="password"
                  register={register}
                  error={errors.pin}
                  onChange={onChange}
                />
              </div>
              <div className="flex flex-col items-center justify-center text-center md:block w-[70%] mt-5">
                {errMsg && (
                  <p className="text-red-500 font-bold text-md mb-4">
                    {errMsg}
                  </p>
                )}
                <CustomButton buttonLabel="Login" isLoading={isLoading} />
              </div>
              {/* <a
                href={"/epc/forgot-password"}
                className={`text-[${colors.green}] font-normal underline w-1/2 flex items-center justify-center text-xl sm:text-[16px]`}
              >
                Forgot password?
              </a> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginProforma;
